import { React, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';

import axios from 'axios';
import { Global } from '../../../Global';

import '../../../../assets/css/nuevoRegistro.css';

import Loading from '../../../elementos/Loading';
import HeaderVista from '../../../elementos/HeaderVista';
import TituloMini from '../../../elementos/TituloMini';
import Error from '../../../elementos/Error';
import Snack from '../../../elementos/Snack';


import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';


import CheckIcon from '@mui/icons-material/Check';


export default function ClienteGcalendarSincronizar() {

    const [estadoVista, setEstadoVista] = useState('loading');
    const [snackOpen, setSnackOpen] = useState({ open: false, message: '', severity: 'error' });

    const [dominio, setDominio] = useState('');
    const [errorMessage, setErrorMessage] = useState('Al parecer ocurrió un error.');


    const urlParams = useParams();

    const handleSubmit = () => {

        if (estadoVista !== 'loading') {
            setEstadoVista('loading');

            axios.post(`${Global.url_api}cliente/gcalendar/${dominio}/sincronizar`, {}, { headers: { Authorization: localStorage.getItem("token") } })
                .then(res => {

                    setEstadoVista('cargado')

                    setSnackOpen({
                        open: true,
                        message: `Se actualizaron ${res.data?.exitos} turnos. ${res.data?.errores} errores.`,
                        severity: 'success'
                    })


                })
                .catch((error) => {
                    if (error?.response?.data?.message) {
                        setErrorMessage(error?.response?.data.message)
                    }
                    setEstadoVista('error')
                });
        }

    }

    useEffect(() => {

        axios.get(Global.url_api + 'cliente/' + urlParams.id, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                setDominio(res.data.dominio);

                setEstadoVista('cargado');

            })
            .catch((error) => {
                console.log(error?.response?.data);
                setEstadoVista('error')
            });

    }, [urlParams.id]);



    if (estadoVista === 'loading') return (<Loading />)

    if (estadoVista === 'error') return (<Error message={errorMessage} />)

    if (estadoVista === 'cargado')
        return (
            <>
                <HeaderVista
                    volverTo={"/clientes/" + urlParams.id}
                    titulo={"Sincronizar Gcalendar " + dominio}
                />
                <Container className="nuevoRegistro" component="main" maxWidth="lg">
                    <Grid container spacing={2}>
                        <br />
                        <Grid item xs={12} >
                            <TituloMini titulo="Sincronizar Google Calendar">Al hacer click en el botón, comenzará la sincronización.</TituloMini>
                        </Grid>
                        <Grid item xs={12}>
                            <p>Esta sincronización puede demorar varios minutos (mas de 10) hasta completarse.</p>
                            <p>Si el cliente tiene muchos turnos pendientes (mas de 50) puede dar error por timeout. Si da error verificar con el cliente si están los turnos.</p>
                        </Grid>
                    </Grid>
                </Container>
                <Container className="nuevoRegistro footer" component="main" maxWidth="lg">
                    <Grid container>
                        <Grid className="botones" item xs={12} >
                            <Button onClick={handleSubmit} type="button" variant="contained" color="success" startIcon={<CheckIcon />} >
                                Sincronizar
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
                <Snack estado={snackOpen} setSnackOpen={setSnackOpen} />
            </>
        )

}